export const downloadContent = (name, content) => {
  const atag = document.createElement('a');
  const file = new Blob([content], { type: 'text/plain' });
  atag.href = URL.createObjectURL(file);
  atag.download = name;
  atag.click();
};



// WEBPACK FOOTER //
// ./src/utils/fileGenerator.ts